// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"2631e72b","498":"e3aea48d","703":"03cd260b","787":"306724c9"}[chunkId] + ".chunk.js";
};